import { api } from '../api'
import type { User } from '@homeviews/models'

type UsersResponse = User[]

export const companyUsersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCompanyUsers: builder.query<UsersResponse, any>({
      query: ({ sort }) => {
        return {
          url: `/users`,
          params: {
            ...sort,
          },
        }
      },
      providesTags: <any>['CompanyUsers'],
    }),
    getCompanyUsersMatrix: builder.query<UsersResponse, void>({
      query: () => {
        return {
          url: `/users/matrix`,
        }
      },
      providesTags: <any>['CompanyUsers'],
    }),
    getCompanyUser: builder.query<any, { id: number }>({
      query: ({ id }) => {
        return {
          url: `/users/${id}`,
        }
      },
      providesTags: <any>['CompanyUser'],
    }),
    createCompanyUser: builder.mutation({
      query: ({ data }) => {
        return {
          url: 'users',
          method: 'POST',
          body: data,
        }
      },
      invalidatesTags: <any>['CompanyUsers'],
    }),
    updateCompanyUser: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `/users/${id}`,
          method: 'PUT',
          body: data,
        }
      },
      invalidatesTags: <any>['CompanyUsers', 'CompanyUser'],
    }),
    updateCompanyUserPermissions: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `/users/${id}/permissions`,
          method: 'PUT',
          body: data,
        }
      },
      invalidatesTags: <any>['CompanyUsers', 'CompanyUser'],
    }),
    deleteCompanyUser: builder.mutation<any, { id: number }>({
      query: ({ id }) => {
        return {
          url: `/users/${id}`,
          method: 'DELETE',
        }
      },
      invalidatesTags: <any>['CompanyUsers'],
    }),
  }),
})

export const {
  useGetCompanyUserQuery,
  useGetCompanyUsersQuery,
  useGetCompanyUsersMatrixQuery,
  useCreateCompanyUserMutation,
  useUpdateCompanyUserMutation,
  useUpdateCompanyUserPermissionsMutation,
  useDeleteCompanyUserMutation,
} = companyUsersApi
